import React from 'react';
import { Box } from '@mui/material';
const HourCell = React.memo(({
  day,
  hour,
  isSelected,
  onMouseDown,
  onMouseEnter
}) => <Box onMouseDown={() => onMouseDown(day, hour)} onMouseEnter={() => onMouseEnter(day, hour)} sx={{
  height: '30px',
  borderBottom: '1px solid #fff',
  backgroundColor: isSelected ? '#7CB9E8' : '#f5f5f5',
  cursor: 'pointer',
  transition: 'background-color 0.1s',
  '&:hover': {
    opacity: 0.8
  }
}} />);
HourCell.displayName = 'HourCell';
export default HourCell;